import { useMutation, useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { CookiesHelper } from "../helpers/cookies.helper";

import { HMISaveFeedback } from "../types/services.interface";
import { EtyFeedback } from "../types/entities.interface";

export const useSaveFeedback = () => {
    const mutationFn = async (data: HMISaveFeedback): Promise<void> => {
        const token = CookiesHelper.get(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        await api.post('/feedbacks/save', data.payload);
    };

    return useMutation({
        mutationFn,
        onMutate: (variables) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (_, variables) => {
            variables.setIsSuccess(true);
        },
        onError: (error: any) => {
            window.alert(error?.response?.data?.message || 'Something went wrong.');
        },
        onSettled: (_, __, variables) => {
            variables.setIsProcessing(false);
        },
    });
};

export const useGetFeedbacksForCompleteData = (sessionId: string | null) => {
    const queryFn = async (): Promise<EtyFeedback[]> => {
        const res = await api.get(`/feedbacks/complete-data/${sessionId}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['feedbacks-for-complete-data', sessionId],
        queryFn,
        retry: false,
        enabled: !!sessionId,
    });
};